export default "__VITE_ASSET__0qLqdtms__"